import { Injectable } from '@angular/core';
import { NoteType } from '../../model/crm/note-type';
import { sortByName } from 'src/app/utils/utils';
import { AOR } from 'src/app/model/locations/aor';

@Injectable({
  providedIn: 'root',
})
export class NoteTypeBuilderService {
  constructor() {}

  buildNoteType(item: any): NoteType {
    const categories = [...item.Categories];
    const aors = [...item.aors];
    const noteType = {
      id: item.id,
      name: item.name,
      active: item.active,
      createdBy: item.createdBy,
      createdDate: item.createdDate,
      updatedBy: item.updatedBy,
      updatedDate: item.updatedDate,
      version: item.version,
      aors:
        aors && aors.length > 0
          ? aors.map((aor: AOR) => ({
              id: aor.id,
              name: aor.name,
              abbreviation: aor.abbreviation,
            }))
          : [],
      aorString: aors
        ? aors
            .sort(sortByName)
            .map((aor) => aor.abbreviation)
            .join(', ')
        : '',
      categories: categories
        ? categories.map((category) => ({
            id: category.id,
            name: category.name,
          }))
        : [],
      categoryString: categories
        ? categories
            .sort(sortByName)
            .map((bu) => bu.name)
            .join(', ')
        : '',
    };

    return noteType;
  }
}
